export enum Direction {
  North = 0,
  East,
  South,
  West,
}
